import React, { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { ExclamationCircleIcon } from "@heroicons/react/outline";
import Button from "components/Button";
import Modal from "components/Modal";

const OrganisationSettingsLayout = ({
  open,
  close,
  hasError,
  children,
  update,
  header,
}: {
  open: boolean;
  close: () => void;
  hasError?: boolean;
  children: ReactNode;
  update?: () => Promise<void>;
  header?: React.ReactNode;
}) => {
  const { t } = useTranslation();
  const [updateLoading, setUpdateLoading] = React.useState(false);

  const onClickSave = async () => {
    setUpdateLoading(true);
    await update?.();
    setUpdateLoading(false);
    close();
  };

  return (
    <Modal
      title={header}
      isOpen={open}
      setIsOpen={close}
      containerClassName="md:max-w-4xl !p-0"
      closeButton
      footer={
        !!update ? (
          <div className="flex items-center justify-between w-full">
            <Button type="gray" width="fit-content" onClick={close}>
              {t("commons.cancel")}
            </Button>
            <div className="flex items-center">
              <div className="text-red-600 text-sm flex mr-2">
                {hasError && (
                  <>
                    <ExclamationCircleIcon width={19} className="mr-1" />
                    {t("commons.closeErrorMessage")}
                  </>
                )}
              </div>
              <Button
                type="primary"
                width="fit-content"
                onClick={onClickSave}
                disable={hasError}
                loading={updateLoading}
              >
                {t("commons.save")}
              </Button>
            </div>
          </div>
        ) : (
          <Button type="link" width="fit-content" onClick={close}>
            {t("commons.close")}
          </Button>
        )
      }
    >
      {children}
    </Modal>
  );
};
export default OrganisationSettingsLayout;
